export type TypeWindow = 'default' | 'entityImportDetail' | 'investorImportDetail' | 'groupImportDetail';

export interface ILegalEntityImport {
  entityResponse: IEntityResponse;
  householdResponse: IHouseholdResponse;
  groupResponse: IGroupResponse;
}

export interface IEntityResponse {
  newEntitiesCount: number;
  updatedEntitiesCount: number;
  unchangedEntitiesCount: number;
  entityImportComparisons: IEntityImportComparison[];
}

export interface IEntityImportComparison {
  id: string;
  entityCRMId: string;
  entityName: string;
  householdName: string;
  fieldsModifiedCount: number;
  status: string;
  isNew: boolean;
  entityFieldComparisons: IEntityFieldComparison[];
}

export interface IEntityFieldComparison {
  fieldName: string;
  currentValue: string;
  newValue: string;
  status: string;
  tooltip: string;
}

export interface IHouseholdResponse {
  newHouseholdsCount: number;
  updatedHouseholdsCount: number;
  householdsToDeleteCount: number;
  householdComparisons: IHouseholdComparison[];
}

export interface IHouseholdComparison {
  householdName: string;
  totalEntities: number;
  entitiesAdded: number;
  entitiesRemoved: number;
  advisorEmail: string;
  advisorConflict: string;
  status: string;
  entityAdvisors: IEntityAdvisor[];
}

export interface IEntityAdvisor {
  entityName: string;
  existingEmail: string;
  importEmail: string;
  tooltip: string;
  status: string;
}

export interface IGroupResponse {
  newGroupsCount: number;
  updateGroupsCount: number;
  groupsToDeleteCount: number;
  groupImportComparisons: IGroupImportComparison[];
}

export interface IGroupImportComparison {
  householdName: string;
  groupName: string;
  totalGrouped: number;
  newlyGrouped: number;
  ungrouped: number;
  primaryEntityName: string;
  oldPrimaryEntityId?: string;
  status: string;
  tooltip: string;
  entityGroups: IEntityGroup[];
}

export interface IEntityGroup {
  id: string;
  entityName: string;
  isPrimaryEntity: boolean;
  status: string;
}

export enum ImportInvestorEntitiesTenantRadioButtonOptionEnum {
  PlatformManager = 'Platform Manager',
  SpecificAdvisoryFirm = 'Specific Advisory Firm'
}

export enum ImportInvestorEntitiesUpdateMethodOptionEnum {
  UpdateUsingEntityCRMID = 'Update using Entity CRM ID',
  UpdateUsingEntityStaticID = 'Update using Entity Static ID'
}
